<template>
  <div
    class="container"
    :style="fileList.length ? 'margin-bottom: -20px;' : ''">
    <!-- 查看 -->
    <ViewFileItem
      v-for="item in fileList"
      :key="item.path"
      :file="item"
      :del="!disabled"
      @delete="handleFileDelete">
    </ViewFileItem>
    <!-- 上传 -->
    <div class="upload-container" v-if="!disabled && fileList.length < maxFiles">
      <div class="upload-icon">
        <img src="@/assets/image/upload/upload.png" alt="upload">
      </div>
      <p class="upload-text">{{ $t('上传文件') }}</p>
      <input
        type="file"
        ref="fileInput"
        class="upload-input"
        :accept="accept"
        :multiple="false"
        @change="handleFileUpload">
    </div>
  </div>
</template>

<script>
import uploadApi from '@/api/upload'
export default {
  props: {
    // 文件列表
    fileList: {
      type: Array,
      default () {
        return []
      }
    },
    // 后端接口不支持multiple
    // multiple: {
    //   type: Boolean,
    //   default: false
    // },
    // 支持上传的文件类型
    accept: {
      type: String,
      default: 'image/png,image/jpeg,image/jpg,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 允许上传的最大数量
    maxFiles: {
      type: Number,
      default: 10
    },
    // 单个文件的最大size，单位M
    sizeLimit: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handleFileUpload (e) {
      const { files } = e.target
      const { sizeLimit } = this
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const { type, size } = file
        const isLt2M = size / 1024 / 1024 <= sizeLimit
        if (!isLt2M) {
          this.$warn(`${this.$t('上传文件大小不能超过')}${sizeLimit}MB!`)
          continue
        }
        uploadApi.uploadFile({
          file
        }).then(res => {
          if (res) {
            // name path
            this.fileList.push({
              type,
              ...res
            })
            // 上传完成后 把input的value置为'' 这样才能上传重复的文件
            this.$refs.fileInput.value = ''
          }
        }).catch(err => {
          console.error(err)
        })
      }
    },
    handleFileDelete (file) {
      const index = this.fileList.findIndex(item => item.path === file.path)
      this.fileList.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="less">
.container {
  display: flex;
  flex-wrap: wrap;
  .process-container {
    width: 120px;
    height: 120px;
    border-radius: 4px;
    border: 1px dashed #E6E9F4;
  }
  .upload-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    border-radius: 4px;
    border: 1px dashed #E6E9F4;
    cursor: pointer;
    &:hover {
      border-color: #BBC0D8;
    }
    .upload-icon {
      width: 60px;
      height: 60px;
      margin-bottom: 7px;
      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .upload-text {
      font-size: 14px;
      font-weight: 300;
      color: #BBC0D8;
      line-height: 14px;
      user-select: none;
    }
    .upload-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
      width: 100%;
      height: 100%;
      padding: 0;
      cursor: pointer;
      opacity: 0;
    }
  }
}
</style>
